import React from "react";

import { CATEGORY_ICONS } from "./categoryIcons";
import Troubleshoot from "@/assets/icons/troubleshoot.svg?react";

type CategoryIconProps = {
  category: string;
  className?: string;
};

export const CategoryIcon = ({
  category,
  className = "text-[#064C68]",
}: CategoryIconProps) => {
  const iconMap = Object.fromEntries(
    Object.entries(CATEGORY_ICONS).map(([key, value]) => [
      key.toLowerCase(),
      value,
    ]),
  );

  const IconComponent = iconMap[category.toLowerCase()] || Troubleshoot;
  return <IconComponent className={className} />;
};
